import React, { useEffect, useState } from "react";
const DashboardTiles = ({ tilesData, onfilterChange,onResetPagination }) => {
    const [tiles, setTiles] = useState(tilesData);
    const [dashTilesData, setDashTilesData] = useState([]);
    const [tileCounter, setTileCounter] = useState(0);
    const [tilesFilter, setTilesFilter] = useState('TL')
    // For Dashboard Tiles
    useEffect(() => {
        const tilesData = [];
        for (let z = tileCounter; z < tileCounter + 7 && z < tiles.length; z++) {
            tilesData.push(tiles[z]);
        }
        setDashTilesData(tilesData); // For Dashboard Tiles
    }, [tileCounter, tiles]);
    useEffect(() => {
        // Call onDateChange on mount to pass initial dates
        onfilterChange(tilesFilter);
    }, []); // Empty dependency array to run only on mount
    const filterdashboard = (filterText) => {
        setTilesFilter(filterText)
    }
    useEffect(() => {
        // Call onDateChange whenever fromDate or toDate changes
        onfilterChange(tilesFilter);
    }, [tilesFilter]);
    const getPrevTiles = () => {
        if (tileCounter > 0) {
            setTileCounter(prevCounter => prevCounter - 1);
        }
    };

    const getNextTiles = () => {
        if (tileCounter + 7 < tiles.length) {
            setTileCounter(prevCounter => prevCounter + 1);
        }
    };
    const getStatusColorForTiels = (status) => {
        switch (status) {
            case "Total Loans":
                return "bg-primary"; // primary
            case "Errored Loans":
                return "bg-danger"; // danger
            case "Failed Loans":
                return "bg-danger-subtle"; // danger-subtle
            case "In Progress":
                return "bg-warning"; // warning
            case "Review for Approval":
                return "bg-info"; // info
            case "Review for Decline":
                return "bg-secondary"; // secondary
            case "Pending/Incomplete":
                return "bg-warning-subtle"; // warning-subtle
            case "Completed Loans":
                return "bg-success"; // secondary
            default:
                return "bg-primary"; // Default color
        }
    }
    // For Dashboard Tiles
    return (
        <section className="tiles-wrapper">
            <div className="container-fluid">
                <div className="row">
                <div className="col-sm-1  d-flex justify-content-center">
            <button className="btn btn-info btn-sm btn-circle scroll-button left" aria-label="Scroll left" onClick={getPrevTiles} disabled={tileCounter === 0}>❮</button>
            </div>

            <div className="tiles-container col-sm-10 d-flex justify-content-center" id="tiles">
                {dashTilesData.map(detail => (
                    <div
                        className={`tile ${detail.TSN === tilesFilter ? "active" : ""}`}
                        onClick={() => {filterdashboard(detail.TSN);onResetPagination()}}
                        role="button"
                        tabIndex="0"
                        aria-label={`Filter by ${detail.TH}: ${detail.Cnt} loans`}
                    >
                        <div className={`count ${getStatusColorForTiels(detail.TH)}`}>{detail.Cnt}</div>
                        <div className='name' >{detail.TH}</div>

                    </div>
                ))}
            </div>
            <div className="col-sm-1 d-flex justify-content-center">
            <button className="btn btn-info btn-sm btn-circle scroll-button right" aria-label="Scroll right" onClick={getNextTiles} disabled={tileCounter + 7 >= tiles.length}>❯</button>
            </div>
                </div>
            </div>
           
        </section>
    );
};
export default DashboardTiles;